"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backendOrder = void 0;
exports.backendOrder = function (axios) {
    return {
        postOrdersSpecifications: function (postOrdersSpecifications) {
            return axios.post('/orders/specifications', postOrdersSpecifications.data);
        },
        getOrdersSearchTypes: function (getOrdersSearchTypesRequest) {
            return axios.get('/orders/searchTypes', getOrdersSearchTypesRequest);
        },
        getOrdersByOrderNo: function (getOrdersByOrderNoRequest) {
            return axios.get("/orders/" + getOrdersByOrderNoRequest.params.orderNo, getOrdersByOrderNoRequest);
        },
        // 주문상세 혜택지급내역의 사은품 조회
        getOrdersOrderNoFreeGifts: function (getOrdersOrderNoFreeGiftsRequest) {
            return axios.get("/orders/" + getOrdersOrderNoFreeGiftsRequest.pathParams.orderNo + "/free-gifts");
        },
        deleteOrders: function (deleteOrdersRequest) {
            return axios.delete('/orders', deleteOrdersRequest);
        },
        postOrdersBuyCount: function (postOrdersBuyCount) {
            return axios.post('/orders/buy-count', postOrdersBuyCount.data);
        },
        getOrdersByUser: function (request) {
            return axios.get('/orders/orders-by-user', request);
        },
        getOrdersExternalFailHistory: function (request) {
            return axios.get('/orders/external-fail-history', request);
        }
    };
};
